
<div class="header">
  <span class="header-text">{{getHeader()}}</span>
</div>
<div class="header-frame">
  <video #headerVideo1 class="header-video active" muted playsinline preload="auto">
    <source src="assets/videos/header-giveaway.webm" type="video/webm">
  </video>
  <video #headerVideo2 class="header-video" muted playsinline preload="auto">
    <source src="assets/videos/header-giveaway.webm" type="video/webm">
  </video>
</div>
<div class="users-container">
  <ul class="user-list" #scrollContainer>
    <li *ngFor="let user of users(); trackBy: trackByUserId" 
        class="user-item"
        @appearAnimation>
        @if(user.is_twitch && user.is_youtube){
          <mat-icon [svgIcon]="'youtube'"></mat-icon>
          <mat-icon [svgIcon]="'twitch'"></mat-icon>
        } @else {
          <mat-icon [svgIcon]="getUserIcon(user)"></mat-icon>
        }
      @if(giveawayData()?.state === 'winners' ) {
        {{ user.username }} <span class="dot-separator">•</span>  $ {{ user.amount }}
      } @else { 
         {{ user.username}}
      }
    </li>
  </ul>
</div>
<div class="body-frame">
  <video #bodyVideo1 class="body-video active"  muted playsinline preload="auto">
    <source src="assets/videos/body-giveaway.webm" type="video/webm">
  </video>
  <video #bodyVideo2 class="body-video" muted playsinline preload="auto">
    <source src="assets/videos/body-giveaway.webm" type="video/webm">
  </video>
</div>
